


// import React, { useState, useEffect } from 'react';
// import './PhemeLanding.css'; // Make sure to import the CSS file!

// // --- IMPORTS ---
// import Purpose from './components/Purpose';
// import Guidelines from './components/Guidelines';
// import About from './components/About';

// const publicUrl = process.env.PUBLIC_URL || '';

// // --- LIGHTWEIGHT IMAGE COMPONENT ---
// const FastImage = ({ src, alt, priority = false }) => {
//   const [isLoaded, setIsLoaded] = useState(false);

//   return (
//     <img
//       src={src}
//       alt={alt}
//       // "eager" for first image, "lazy" for others. huge speed boost.
//       loading={priority ? "eager" : "lazy"} 
//       decoding="async"
//       onLoad={() => setIsLoaded(true)}
//       className={`bg-image ${isLoaded ? 'image-loaded' : 'image-loading'}`}
//     />
//   );
// };

// // --- DATA ---
// const allSlides = [
//   { text: "", subtext: "", img: `${publicUrl}/images/horse.jpg` }, // Dummy
//   { text: "Most people take 20 photos before posting one.", subtext: "Machines now generate 34 million images a day with zero self-doubt.", img: `${publicUrl}/images/onboarding/img2.jpg`, imgMobile: `${publicUrl}/images/onboarding/img2_mobile.jpg` },
//   { text: "While we hesitate,", subtext: "synthetic is winning.", img: `${publicUrl}/images/onboarding/img1.jpg`, imgMobile: `${publicUrl}/images/onboarding/img1_mobile.jpg` },
//   { text: "We're self-censoring our humanity", subtext: "just as it matters most.", img: `${publicUrl}/images/onboarding/img3.jpg`, imgMobile: `${publicUrl}/images/onboarding/img3_mobile.jpg` },
//   { text: "Join the living internet.", subtext: "No algorithms. Just what's real.", img: `${publicUrl}/images/onboarding/img4.jpg`, imgMobile: `${publicUrl}/images/onboarding/img4_mobile.jpg` },
//   { text: "Your life is in the drafts", subtext: "", img: `${publicUrl}/images/onboarding/img5.jpg`, imgMobile: `${publicUrl}/images/onboarding/img5_mobile.jpg` }
// ];

// const posterSlides = allSlides.slice(1, 5);

// export default function PhemeLanding({ onGetStarted }) {
//   // We still need this hook just to switch the image SOURCE string.
//   // But sizing is handled by CSS now.
//   const [isMobile, setIsMobile] = useState(false);
  
//   useEffect(() => {
//     // Only run this once on mount to check initial size
//     const checkMobile = () => setIsMobile(window.innerWidth < 768);
//     checkMobile();
//     window.addEventListener('resize', checkMobile);
//     return () => window.removeEventListener('resize', checkMobile);
//   }, []);

//   const [showMenu, setShowMenu] = useState(false);
//   const [activePage, setActivePage] = useState(null);

//   const handleBackToLanding = () => { setActivePage(null); setShowMenu(true); };
//   const handleNavClick = (page) => { setActivePage(page); setShowMenu(false); };

//   // Conditional rendering for Sub-Pages is fine as they are totally separate screens
//   if (activePage === 'purpose') return <Purpose onBack={handleBackToLanding} />;
//   if (activePage === 'guidelines') return <Guidelines onBack={handleBackToLanding} />;
//   if (activePage === 'about') return <About onBack={handleBackToLanding} />;

//   return (
//     <div className="snap-container">
      
//       {/* --- MENU BUTTON --- */}
//       <button
//         onClick={() => setShowMenu(!showMenu)}
//         className="menu-btn"
//         style={{
//           ...styles.floatingMenuBtn, // Kept minimal inline for position
//         }}
//         aria-label="Menu"
//       >
//         <span style={{ fontSize: '1.2rem', lineHeight: 1 }}>{showMenu ? '✕' : '☰'}</span>
//       </button>

//       {/* --- MENU OVERLAY (Always in DOM, toggled via CSS class) --- */}
//       <div className={`menu-overlay ${showMenu ? 'open' : ''}`}>
//         <nav style={styles.menuNav}>
//           <div onClick={() => handleNavClick('purpose')} style={styles.menuLink}>
//             <span style={styles.menuNumber}>01</span> The Purpose
//           </div>
//           <div onClick={() => handleNavClick('guidelines')} style={styles.menuLink}>
//             <span style={styles.menuNumber}>02</span> Guidelines
//           </div>
//           <div onClick={() => handleNavClick('about')} style={styles.menuLink}>
//             <span style={styles.menuNumber}>03</span> Who is this?
//           </div>
//         </nav>
//       </div>

//       {/* --- GLOBAL NOISE --- */}
//       <div style={styles.globalNoiseOverlay}></div>

//       {/* --- SCROLL SNAP SECTIONS --- */}
//       {posterSlides.map((slide, index) => {
//         const isLastPanel = index === posterSlides.length - 1;
        
//         return (
//           <div key={index} className="snap-section">
            
//             {/* Background Image */}
//             <div style={{ position: 'absolute', inset: 0, zIndex: 0 }}>
//                <FastImage
//                 src={isMobile && slide.imgMobile ? slide.imgMobile : slide.img}
//                 alt=""
//                 // Priority true for the first image only!
//                 priority={index === 0} 
//               />
//               <div style={styles.darkGradient} />
//             </div>

//             {/* Text Content */}
//             <div className="text-overlay">
//               <h2 className="hero-text">
//                 {slide.text}
//               </h2>
//               {slide.subtext && (
//                 <p className="sub-text">{slide.subtext}</p>
//               )}

//               {isLastPanel && (
//                 <div style={{ marginTop: '3rem' }}>
//                   <button onClick={onGetStarted} style={styles.ctaButton}>
//                     Open your drafts →
//                   </button>
//                 </div>
//               )}
//             </div>

//             {/* Scroll Indicator (Hide on last) */}
//             {!isLastPanel && (
//               <div className="scroll-indicator">
//                 <span style={{opacity: 0.5, fontSize: '0.8rem'}}>Scroll</span>
//                 <div style={styles.scrollLine}></div>
//               </div>
//             )}
//           </div>
//         );
//       })}
//     </div>
//   );
// }

// // Minimal inline styles for things that don't change or need specific asset URLs
// const styles = {
//   floatingMenuBtn: {
//     position: 'fixed',
//     top: '2rem',
//     right: '2rem',
//     zIndex: 100,
//     background: 'rgba(0,0,0,0.4)',
//     backdropFilter: 'blur(8px)',
//     border: '1px solid rgba(255,255,255,0.2)',
//     color: '#fff',
//     width: '50px',
//     height: '50px',
//     borderRadius: '50%',
//     cursor: 'pointer',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     /* Note: Transition handled in CSS class */
//   },
//   menuNav: {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '2rem',
//   },
//   menuLink: {
//     color: '#fff',
//     fontSize: '2rem',
//     fontFamily: "'Georgia', serif",
//     cursor: 'pointer',
//     opacity: 0.8,
//     transition: 'opacity 0.2s',
//   },
//   menuNumber: {
//     fontFamily: 'sans-serif',
//     fontSize: '0.8rem',
//     opacity: 0.5,
//     marginRight: '1rem',
//     verticalAlign: 'middle',
//   },
//   darkGradient: {
//     position: 'absolute',
//     inset: 0,
//     background: 'linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.4) 50%, rgba(0,0,0,0.2) 100%)',
//     zIndex: 1,
//   },
//   ctaButton: {
//     background: '#fff',
//     color: '#000',
//     border: 'none',
//     padding: '1rem 2.5rem',
//     borderRadius: '50px',
//     fontFamily: "'Helvetica Neue', sans-serif",
//     fontWeight: '600',
//     fontSize: '1rem',
//     cursor: 'pointer',
//     boxShadow: '0 0 20px rgba(255,255,255,0.2)',
//   },
//   scrollLine: {
//     width: '1px',
//     height: '40px',
//     background: 'linear-gradient(to bottom, #fff, transparent)',
//   },
//   globalNoiseOverlay: {
//     position: 'fixed',
//     inset: 0,
//     zIndex: 5,
//     pointerEvents: 'none',
//     opacity: 0.07,
//     backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)' opacity='1'/%3E%3C/svg%3E")`,
//   },
// };

import React, { useState, useEffect } from 'react';
import './PhemeLanding.css'; 

// --- IMPORTS ---
import Purpose from './components/Purpose';
import Guidelines from './components/Guidelines';
import About from './components/About';

const publicUrl = process.env.PUBLIC_URL || '';

// --- LIGHTWEIGHT IMAGE COMPONENT ---
const FastImage = ({ src, alt, priority = false }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <img
      src={src}
      alt={alt}
      loading={priority ? "eager" : "lazy"} 
      decoding="async"
      onLoad={() => setIsLoaded(true)}
      className={`bg-image ${isLoaded ? 'image-loaded' : 'image-loading'}`}
    />
  );
};

// --- DATA ---
// We combine the "Option 8" Hook with the original "Manifesto"
const posterSlides = [
  { 
    // SLIDE 1: The "Option 8" Hook (Summary)
    // Uses img5 (Drafts) because it fits the "You have drafts" text perfect.
    text: "Machines don't have drafts. You do.", 
    subtext: "Join the living internet.", 
    img: `${publicUrl}/images/onboarding/img1.jpg`, 
    imgMobile: `${publicUrl}/images/onboarding/img5_mobile.jpg`,
    hasButton: true 
  },
  { 
    // SLIDE 2: Original Start
    text: "Most people take 20 photos before posting one.", 
    subtext: "Machines now generate 34 million images a day with zero self-doubt.", 
    img: `${publicUrl}/images/onboarding/img2.jpg`, 
    imgMobile: `${publicUrl}/images/onboarding/img2_mobile.jpg` 
  },
  { 
    // SLIDE 3: Original Conflict
    text: "While we hesitate,", 
    subtext: "synthetic is winning.", 
    img: `${publicUrl}/images/onboarding/img1.jpg`, 
    imgMobile: `${publicUrl}/images/onboarding/img1_mobile.jpg` 
  },
  { 
    // SLIDE 4: Original Crisis
    text: "We're self-censoring our humanity", 
    subtext: "just as it matters most.", 
    img: `${publicUrl}/images/onboarding/img3.jpg`, 
    imgMobile: `${publicUrl}/images/onboarding/img3_mobile.jpg` 
  },
  { 
    // SLIDE 5: Original Resolution
    text: "Join the living internet.", 
    subtext: "No algorithms. Just what's real.", 
    img: `${publicUrl}/images/onboarding/img4.jpg`, 
    imgMobile: `${publicUrl}/images/onboarding/img4_mobile.jpg`,
    hasButton: true 
  }
];

export default function PhemeLanding({ onGetStarted }) {
  const [isMobile, setIsMobile] = useState(false);
  
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const [showMenu, setShowMenu] = useState(false);
  const [activePage, setActivePage] = useState(null);

  const handleBackToLanding = () => { setActivePage(null); setShowMenu(true); };
  const handleNavClick = (page) => { setActivePage(page); setShowMenu(false); };

  if (activePage === 'purpose') return <Purpose onBack={handleBackToLanding} />;
  if (activePage === 'guidelines') return <Guidelines onBack={handleBackToLanding} />;
  if (activePage === 'about') return <About onBack={handleBackToLanding} />;

  return (
    <div className="snap-container">
      
      {/* --- MENU BUTTON --- */}
      <button
        onClick={() => setShowMenu(!showMenu)}
        className="menu-btn"
        style={styles.floatingMenuBtn}
        aria-label="Menu"
      >
        <span style={{ fontSize: '1.2rem', lineHeight: 1 }}>{showMenu ? '✕' : '☰'}</span>
      </button>

      {/* --- MENU OVERLAY --- */}
      <div className={`menu-overlay ${showMenu ? 'open' : ''}`}>
        <nav style={styles.menuNav}>
          <div onClick={() => handleNavClick('purpose')} style={styles.menuLink}>
            <span style={styles.menuNumber}>01</span> The Purpose
          </div>
          <div onClick={() => handleNavClick('guidelines')} style={styles.menuLink}>
            <span style={styles.menuNumber}>02</span> Guidelines
          </div>
          <div onClick={() => handleNavClick('about')} style={styles.menuLink}>
            <span style={styles.menuNumber}>03</span> Who is this?
          </div>
        </nav>
      </div>

      {/* --- GLOBAL NOISE --- */}
      <div style={styles.globalNoiseOverlay}></div>

      {/* --- SCROLL SNAP SECTIONS --- */}
      {posterSlides.map((slide, index) => {
        const isLastPanel = index === posterSlides.length - 1;
        
        return (
          <div key={index} className="snap-section">
            
            {/* Background Image */}
            <div style={{ position: 'absolute', inset: 0, zIndex: 0 }}>
               <FastImage
                src={isMobile && slide.imgMobile ? slide.imgMobile : slide.img}
                alt=""
                // Priority true for first image only
                priority={index === 0} 
              />
              <div style={styles.darkGradient} />
            </div>

            {/* Text Content */}
            <div className="text-overlay">
              <h2 className="hero-text">
                {slide.text}
              </h2>
              {slide.subtext && (
                <p className="sub-text">{slide.subtext}</p>
              )}

              {/* RENDER BUTTON: Only on First Slide OR Last Slide */}
              {slide.hasButton && (
                <div style={{ marginTop: '3rem' }}>
                  <button onClick={onGetStarted} style={styles.ctaButton}>
                    Open your drafts →
                  </button>
                </div>
              )}
            </div>

            {/* Scroll Indicator: Hide on last panel */}
            {!isLastPanel && (
              <div className="scroll-indicator">
                <span style={{opacity: 0.5, fontSize: '0.8rem'}}>Scroll</span>
                <div style={styles.scrollLine}></div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

// --- STYLES ---
const styles = {
  floatingMenuBtn: {
    position: 'fixed',
    top: '2rem',
    right: '2rem',
    zIndex: 100,
    background: 'rgba(0,0,0,0.4)',
    backdropFilter: 'blur(8px)',
    border: '1px solid rgba(255,255,255,0.2)',
    color: '#fff',
    width: '50px',
    height: '50px',
    borderRadius: '50%',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  menuNav: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2rem',
  },
  menuLink: {
    color: '#fff',
    fontSize: '2rem',
    fontFamily: "'Georgia', serif",
    cursor: 'pointer',
    opacity: 0.8,
    transition: 'opacity 0.2s',
  },
  menuNumber: {
    fontFamily: 'sans-serif',
    fontSize: '0.8rem',
    opacity: 0.5,
    marginRight: '1rem',
    verticalAlign: 'middle',
  },
  darkGradient: {
    position: 'absolute',
    inset: 0,
    background: 'linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.4) 50%, rgba(0,0,0,0.2) 100%)',
    zIndex: 1,
  },
  ctaButton: {
    background: '#fff',
    color: '#000',
    border: 'none',
    padding: '1rem 2.5rem',
    borderRadius: '50px',
    fontFamily: "'Helvetica Neue', sans-serif",
    fontWeight: '600',
    fontSize: '1rem',
    cursor: 'pointer',
    boxShadow: '0 0 20px rgba(255,255,255,0.2)',
  },
  scrollLine: {
    width: '1px',
    height: '40px',
    background: 'linear-gradient(to bottom, #fff, transparent)',
  },
  globalNoiseOverlay: {
    position: 'fixed',
    inset: 0,
    zIndex: 5,
    pointerEvents: 'none',
    opacity: 0.07,
    backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)' opacity='1'/%3E%3C/svg%3E")`,
  },
};